var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footer-follow-us-section__wrapper"},[_c('p',{staticClass:"footer-follow-us-section__title subtitle-3"},[_vm._v("Follow Us")]),_vm._v(" "),_c('footer-socials',{attrs:{"items":_vm.footerSocials}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }